import { render } from "./polygonMapComponent.vue?vue&type=template&id=4b65036c&scoped=true"
import script from "./polygonMapComponent.vue?vue&type=script&lang=js"
export * from "./polygonMapComponent.vue?vue&type=script&lang=js"

import "./polygonMapComponent.vue?vue&type=style&index=0&id=4b65036c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b65036c"]])

export default __exports__